import React from 'react'
import moment from 'moment'
import { useState,useEffect } from 'react';
import PostCard from '../MainPostCard';
import api from "../../lib/api"


export default function CardColumn(props) {
//la busqueda se realiza por usuario (post.user.name)
//titulo (post.title)
//y tags (post.tag_list.join(" "))
    const {posts} = props

    const getYear = date => moment(date).year();
	const getMonth = date => moment(date).month();
	const getWeek = date => moment(date).isoWeek();
	const filterByYear = posts => posts.filter(post=>post.year==moment(new Date()).year())
	const filterByMonth = posts => posts.filter(post=>post.month==moment(new Date()).month() && post.year==moment(new Date()).year())
	const filterByWeek = posts => posts.filter(post=>post.week==moment(new Date()).isoWeek() && post.year==moment(new Date()).year())
    const orderByLatest = posts => [...posts].sort((a,b)=>new Date(b.createdAt).getTime()-new Date(a.createdAt).getTime());
    const filterByLatest = posts => orderByLatest(posts).slice(0,5)
    const shuffledArray = posts => posts.sort((a, b) => 0.5 - Math.random());
    const postsWithDates = posts.map(post=>{
        return {...post,['year']:getYear(post.createdAt),['month']:getMonth(post.createdAt),['week']:getWeek(post.createdAt)}
    })

	const [condition,setCondition] = useState(null);    
	const [filteredPosts,setFilterPosts] = useState(posts)

    useEffect(()=>{       
        setFilterPosts(posts)
        console.log(`los post del ${condition} son: ${filteredPosts}`)

		//.month() te da el mes de ano
		//.isoWeek() te da la semana de ano
		//.year()

    },[posts])
	useEffect(()=>{
		switch(condition){
			case "year":
				setFilterPosts(shuffledArray(filterByYear(postsWithDates)));
				console.log(filteredPosts)
				break;
			case "month":
				setFilterPosts(shuffledArray(filterByMonth(postsWithDates)));
				console.log(filteredPosts)
				break;
			case "week":
				setFilterPosts(shuffledArray(filterByWeek(postsWithDates)));
				console.log(filteredPosts)
				break;
			case "feed":
				setFilterPosts(postsWithDates);
				console.log(filteredPosts)
				break;
			case "infinity":
				setFilterPosts(postsWithDates);
				console.log(filteredPosts)
				break;
            case "latest":
                setFilterPosts(shuffledArray(filterByLatest(postsWithDates)))
                break;
		}
	},[condition])

    return (
        <section className="col-12 col-md-8 col-xl-6 cards-section">
        <nav className="cards-navigation">
            <div className="title">
                <h1 className="subtitle ">Posts</h1>
            </div>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link active" id="feed" data-toggle="tab" 
                    role="tab" aria-controls="nav-feed" aria-selected="true" onClick={()=>setCondition("feed")}>Feed</button>
                <button className="nav-link" id="week" data-toggle="tab" 
                    role="tab" aria-controls="nav-week" aria-selected="false" onClick={()=>setCondition("week")}>Week</button>
                <button className="nav-link" id="month" data-toggle="tab" 
                    role="tab" aria-controls="nav-month" aria-selected="false" onClick={()=>setCondition("month")}>Month</button>
                <button className="nav-link" id="year" data-toggle="tab"  role="tab"
                aria-controls="nav-contact" aria-selected="false" onClick={()=>setCondition("year")}>Year</button>
            <button className="nav-link" id="nav-2" data-toggle="tab"  role="tab"
                aria-controls="nav-contact" aria-selected="false" onClick={()=>setCondition("infinity")}>Infinity</button>
            <button className="nav-link" id="latest" data-toggle="tab"  role="tab"
                aria-controls="nav-contact" aria-selected="false" onClick={()=>setCondition("latest")}>Latest</button>
            </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade show active" id="nav-feed" role="tabpanel" aria-labelledby="nav-feed-tab">
            </div>
        </div>
        {filteredPosts.map((post,index)=>{
            return <PostCard key={index} 
                        _id={post._id}
                        image={post.cover_image}
                        name={post.user.name}
                        readable_publish_date={post.readable_publish_date}
                        title={post.title}
                        positive_reactions_count={post.positive_reactions_count}
                        reading_time_minutes={post.reading_time_minutes}
                        tags={post.tags}
                        tag_list={post.tag_list}
                        display={index==0?"d-block":"d-none"}
                        />
        })}
    </section>
    )
}
